import { ComponentSidebarProps } from "./types";
import * as styles from "./styles";

export const ComponentSidebar = ({
  open,
  onClose,
  children,
  width = 350,
  className = "",
  css,
}: ComponentSidebarProps) => {
  const getAsideClass = () => {
    if (open === "open" || open === "opening") {
      return "animate__fadeInLeft";
    } else if (open === "closing" || open === "close") {
      return "animate__fadeOutLeft";
    } else {
      return "";
    }
  };

  return (
    <>
      <aside
        className={`sidebar animate__animated ${styles.sidebar({
          open,
          width,
        })}  ${getAsideClass()} ${className} ${styles._external(css)} `}
      >
        {children}
      </aside>
      {open !== "close-full" && (
        <div onClick={onClose} className={`${styles.layer(open)}`} />
      )}
    </>
  );
};
